import rxios from '../common/rxios'
import { map } from 'rxjs/operators'

export const customerStoryService = {
  getCustomerStoriesIntro$(country) {
    return rxios.get(`/homepage/v1/customer-stories/intro`, { params: { country } }).pipe(map(response => response.data.customerStories))
  },
  getCustomerStoriesMain$(country) {
    return rxios.get(`/homepage/v1/customer-stories/main`, { params: { country } }).pipe(map(response => response.data.customerStories))
  },
  getCustomerStoriesDetail$(country) {
    return rxios.get(`/homepage/v1/customer-stories/detail`, { params: { country } }).pipe(map(response => response.data.customerStories))
  },

  getCustomerStoryDetailSub$(customerStoryId, langCode) {
    return rxios.get(`/homepage/v1/customer-stories/detail/${customerStoryId}`,
      { params: { langCode } }).pipe(map(response => response.data))
  }
}
